<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
export default {
	props: {},
	watch: {},
	data() {
		return {
			//��Ʊ����
			HangData: []
		};
	},
	mounted() {},
	created() {},
	methods: {
		//�ύ
		submit() {
			this.$showConfirm({
				message: '���κ��ַ�Ʊ����Ʊ��Ϊ�����ӷ�Ʊ����������Է�ȷ�ϣ��ύ��ϵͳ��ֱ�����ɺ��ַ�Ʊ����ȷ���Ƿ�����ύ?',
				title: '��ܰ��ʾ'
			}).then(res => {
				if (res == 'confirm') {
					this.$emit('OptionNoteclick', 3);
				} else {
					//ȡ��
				}
			});
		},
		//��һ��
		OptionNoteclick() {
			this.$emit('OptionNoteclick', 3);
		},
		//���� ��һ��
		ReturnReselect() {
			this.$emit('OptionNoteclick', 1);
		},
		//����ɾ����
		AddDelete(e) {
			if (e) {
				this.HangData.push({});
			} else {
				if (this.HangData.length > 0) {
					this.HangData.splice(this.HangData.length - 1, 1);
				}
			}
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
